import Vue from 'vue'

let initializedCallback

const store = {
  state: {
    currentUser: JSON.parse(localStorage.getItem('currentUser')),
    loans: [],
    cards: JSON.parse(sessionStorage.getItem('cards') || '[]'),
    locale: localStorage.getItem('locale'),
    userPinForOTP: JSON.parse(sessionStorage.getItem('userPinForOTP')),
    isInitialized: new Promise((resolve) => { initializedCallback = resolve }),
    isBiometricLoginPromptOpen: false,
    isBiometricLoginErrorOpen: false
  },

  isInitialized() {
    return this.state.isInitialized
  },

  setInitialized() {
    initializedCallback()
    initializedCallback = () => {}
  },

  setUninitialized() {
    this.state.isInitialized = new Promise((resolve) => { initializedCallback = resolve })
  },

  setLocale(locale) {
    localStorage.setItem('locale', locale)
    this.state.locale = locale
  },

  setApplication(application) {
    sessionStorage.setItem('application', JSON.stringify(application))
  },

  setBuffer(o) {
    sessionStorage.setItem('buffer', JSON.stringify(o))
  },

  getBuffer() {
    return JSON.parse(sessionStorage.getItem('buffer'))
  },

  getApplication() {
    const application = sessionStorage.getItem('application')
    return application ? JSON.parse(application) : null
  },

  clearApplication() {
    sessionStorage.removeItem('application')
  },

  setSelectedProduct(product) {
    sessionStorage.setItem('selectedProduct', JSON.stringify(product))
  },

  getSelectedProduct() {
    const product = sessionStorage.getItem('selectedProduct')
    return product ? JSON.parse(product) : null
  },

  clearSelectedProduct() {
    sessionStorage.removeItem('selectedProduct')
  },

  setDraft(draft) {
    sessionStorage.setItem('applicationDraft', JSON.stringify(draft))
  },

  getDraft() {
    const draft = sessionStorage.getItem('applicationDraft')
    return draft ? JSON.parse(draft) : null
  },

  clearDraft() {
    sessionStorage.removeItem('applicationDraft')
  },

  setNewLoanApplicationDraft(draft) {
    localStorage.setItem('newLoanApplicationDraft', JSON.stringify(draft))
  },

  getNewLoanApplicationDraft() {
    const draft = localStorage.getItem('newLoanApplicationDraft')
    return draft ? JSON.parse(draft) : null
  },

  clearNewLoanApplicationDraft() {
    localStorage.removeItem('newLoanApplicationDraft')
  },

  setCurrentUser(user) {
    this.state.currentUser = user
    localStorage.setItem('currentUser', JSON.stringify(user))
    sessionStorage.setItem('loggedIn', user.pin)
  },

  setCustomerCards(cards) {
    this.state.cards.splice(0)
    if (Array.isArray(cards)) {
      for (let i = 0; i < cards.length; i++) {
        Vue.set(this.state.cards, i, cards[i])
      }
    }
    sessionStorage.setItem('cards', JSON.stringify(cards || []))
  },

  getCustomerCards() {
    return this.state.cards
  },

  clearUserPinForOTP() {
    this.state.userPinForOTP = undefined
    sessionStorage.removeItem('userPinForOTP')
  },

  setUserPinForOTP(pin) {
    this.state.userPinForOTP = pin
    sessionStorage.setItem('userPinForOTP', JSON.stringify(pin))
  },

  setPendingApplications(applications) {
    this.state.pendingApplications = applications
    sessionStorage.setItem('pendingApplications', JSON.stringify(applications))
  },

  getPendingApplications() {
    const applications = sessionStorage.getItem('pendingApplications')
    return applications ? JSON.parse(applications) : []
  },

  setLoans(loans) {
    this.state.loans = loans
    sessionStorage.setItem('loans', JSON.stringify(loans))
  },

  getLoans() {
    const loans = sessionStorage.getItem('loans')
    return loans ? JSON.parse(loans) : []
  },

  setWalletBalance(balance) {
    this.state.walletBalance = balance
    sessionStorage.setItem('walletBalance', JSON.stringify(balance))
  },

  getWalletBalance() {
    const walletBalance = sessionStorage.getItem('walletBalance')
    return walletBalance ? JSON.parse(walletBalance) : {}
  },

  setLatestPayout(payout) {
    this.state.latestPayout = payout
    sessionStorage.setItem('latestPayout', JSON.stringify(payout))
  },

  getLatestPayout() {
    const latestPayout = sessionStorage.getItem('latestPayout')
    return latestPayout ? JSON.parse(latestPayout) : {}
  },

  setLoginWithBiometryEnabled() {
    const currentUser = this.state.currentUser
    localStorage.setItem('biometryUser', JSON.stringify({
      lastName: currentUser.lastName,
      firstName: currentUser.firstName,
      pin: currentUser.pin,
      birthDate: currentUser.birthDate
    }))
  },

  setLoginWithBiometryDisabled() {
    localStorage.removeItem('biometryUser')
  },

  getBiometryUser() {
    const biometryUser = localStorage.getItem('biometryUser')
    return biometryUser ? JSON.parse(biometryUser) : {}
  },

  getLoginWithBiometryEnabled() {
    return !!this.getBiometryUser().pin
  },

  logOut() {
    this.state.currentUser = undefined
    this.setCustomerCards([])
    sessionStorage.clear()
    localStorage.removeItem('currentUser')
    const keys = Object.keys(localStorage)
    for (const key of keys) {
      if (key.startsWith('CognitoIdentityServiceProvider.')) {
        localStorage.removeItem(key)
      }
    }
  },

  promoteBiometricLogin(pin) {
    if (this.getBiometryUser().pin === pin) {
      // alert('biometry user ' + pin)
      return
    }
    if (localStorage.getItem(`biometricLoginPromoted:${pin}`) === 'true') {
      // alert('already promoted ' + pin)
      return
    }
    this.state.isBiometricLoginPromptOpen = true
  },

  closeBiometricLoginPrompt() {
    this.state.isBiometricLoginPromptOpen = false
    localStorage.setItem(`biometricLoginPromoted:${this.state.currentUser.pin}`, 'true')
  },

  showBiometricLoginError() {
    this.state.isBiometricLoginErrorOpen = true
  },

  closeBiometricLoginError() {
    this.state.isBiometricLoginErrorOpen = false
  },

  setChatUsername(value) {
    sessionStorage.setItem('chatUsername', value)
  },

  getChatUsername() {
    return sessionStorage.getItem('chatUsername')
  },

  requireToShowPaymentScheduleSurvey() {
    localStorage.setItem('loan-schedule-survey-needed', 'true')
  },
  needsToShowPaymentScheduleSurvey() {
    return localStorage.getItem('loan-schedule-survey-needed') === 'true'
  },
  resetShowPaymentScheduleSurvey() {
    localStorage.removeItem('loan-schedule-survey-needed')
  }
}

export default store
